import type { TaxonomyClass } from "@sitescene/types";

import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import { queryKeys } from "@/api/query-keys";

/** The global taxonomy: every active class, alertable or not. Not org-scoped. */
export const useTaxonomy = () =>
	useQuery({
		queryFn: async () => {
			const response = await apiClient.get<TaxonomyClass[]>(
				ENDPOINTS.shadow.plausibility.taxonomy,
			);
			return response.data;
		},
		queryKey: queryKeys.plausibility.taxonomy,
		staleTime: 5 * 60 * 1000,
	});
